const blogLanding = () => {
  let page = 1;
  const itemsPerPage = 6;

  const blogLandingPageInit = () => {
    if ($('.main-blog#recipes').length) {
      paginationInit(recipeList);
      applyFilters(recipeList);
      applySort(recipeList);
      updatePagination(recipeList);
    } else if ($('.main-blog#journal, .main-blog#news').length) {
      paginationInit(journalList);
      applyFilters(journalList);
      applySort(journalList);
      updatePagination(journalList);
    } else if ($('.main-blog#meet-our-growers').length) {
      paginationInit(growersList);
      updatePagination(growersList);
    }
  };

  const paginationInit = (list) => {
    $('.pagination__load-more').click(function () {
      page++;
      list.show(0, page * itemsPerPage);
      updatePagination(list);
    });
  };

  // match articles with current filters
  const applyFilters = (list) => {
    const currentURL = window.location.href;
    if (currentURL.indexOf('filter=') > -1) {
      list.filter(function (item) {
        const article_tag_list = item.values().card_article_tag_list;
        const urlFilterList = currentURL.split('filter=').slice(1);
        let filterMatch = false;

        urlFilterList.forEach((filterItem) => {
          filterItem = filterItem.replaceAll('&', '');
          filterItem = filterItem.replaceAll('%20', ' ');
          if (article_tag_list.includes(filterItem)) {
            filterMatch = true;
          }
        });
        return filterMatch;
      });
    }
  };

  // sort articles
  const applySort = (list) => {
    list.sort('card_article_created', { order: 'desc' });
    $('.sort_selector_wrapper').on('click', () => {
      $('.sort_selector_wrapper').toggleClass('is-open');
    });
    $('.sort_list li').on('click', (e) => {
      const sort = $(e.target).data('sort');
      if (sort == 'newest') {
        list.sort('card_article_created', { order: 'desc' });
      } else if (sort == 'oldest') {
        list.sort('card_article_created', { order: 'asc' });
      } else if (sort == 'name asc') {
        list.sort('full-unstyled-link', { order: 'asc' });
      } else if (sort == 'name desc') {
        list.sort('full-unstyled-link', { order: 'desc' });
      }
      $('.sort_method').text(sort);
    });
  };

  const updatePagination = (list) => {
    const totalItems = list.matchingItems.length;
    const currentItems = list.visibleItems.length;
    $('.blog_sort_wrapper .total_recipes span').text(totalItems);
    if (currentItems <= totalItems) {
      $('.blog_pagination_container').show();
      const progress = Math.round((currentItems / totalItems) * 100);
      $('.blog_pagination_container .pagination__text').text(
        `you’ve viewed ${currentItems} out of ${totalItems} products`,
      );
      $('.pagination__progress_bar-wrapper .pagination__progress_bar').css(
        'width',
        `${progress}%`,
      );
      if ($('.pagination li').length <= 1) {
        $('.pagination__load-more').hide();
      }
    } else {
      $('.blog_pagination_container').hide();
    }
  };

  blogLandingPageInit();
};

export default blogLanding;
